import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showVanillaLoginDialogue } from '../../../redux/fabricCanvasActions';
import { saveOnlyIfDirtyAndCall } from '../../../redux/projectSaveAndLoader';
import * as gaHelpers from '../../../utilities/GAHelpers/GAHelpers';
import { bindActionCreators } from 'redux';
import { Modal } from 'reactstrap';
import './VanillaLogin.scss';
import { string } from '../../../localization';
import * as CookieUtils from '../../../utilities/CookieUtils/CookieUtils';
import { getCookieActivityNameForLitePatner } from '../../../utilities/HelperFunctions/HelperFunctions';
import * as Constants from '../../../utilities/constants/Constants';

class VanillaLogin extends Component {
  loginIsClicked = () => {
    const { dispatchers, webLinkSaveIdentifier, documentColors } = this.props;
    dispatchers.gaHelpers.sendLoginGAEvents(
      Constants.GA_EVENT_ACTIONS.BEFORE_LOGIN
    );
    dispatchers.saveOnlyIfDirtyAndCall().then(params => {
      if (params[0]) {
        const cookieActivity = getCookieActivityNameForLitePatner(
          webLinkSaveIdentifier
        );
        if (documentColors.length > 0) {
          CookieUtils.saveDocumentColorsCookie(documentColors);
        }

        CookieUtils.saveResumeActivityCookie(
          cookieActivity,
          params[0],
          params[1],
          params[2],
          true,
          ''
        );
      }
      window.open('/lite_partner/hp_id_login', '_self');
    });
  };

  render() {
    const { isLoginOpen, dispatchers } = this.props;
    return (
      <Modal
        isOpen={isLoginOpen}
        className='vanilla-login'
        modalClassName='vanilla-login-modal'
        backdropClassName='vanilla-login-backdrop'
      >
        <div className='header'>
          <button
            type='button'
            aria-label='close'
            className='close-icon'
            onClick={() => {
              // CookieUtils.getResumeActivityCookie(
              //   Constants.VANILLA_LOGIN_COOKIE
              // );
              dispatchers.showVanillaLoginDialogue(false);
            }}
          />
        </div>
        <div className='body'>
          <p className='title'>{string.ENTER_KEY}</p>
          <p>{string.VANILLA_LOGIN_DIALOG_KEY}</p>
          <button
            type='button'
            style={{ border: 'none' }}
            className='button'
            onClick={() => {
              this.loginIsClicked();
            }}
          >
            {string.LOGIN_KEY}
          </button>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    undoInstance: state.fabricCanvas.undoInstance,
    webLinkSaveIdentifier: state.fabricCanvas.webLinkSaveIdentifier,
    envData: state.modal.envData,
    documentColors: state.sideBar.documentColors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      showVanillaLoginDialogue: bindActionCreators(
        showVanillaLoginDialogue,
        dispatch
      ),
      saveOnlyIfDirtyAndCall: bindActionCreators(
        saveOnlyIfDirtyAndCall,
        dispatch
      ),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VanillaLogin);
